<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-home-experience-automation-panel-conversation-volume-summary" v-loading="loading" element-loading-text="Loading...">
    <wy-exp-and-auto-header :selecteddatePeriodRange="viewByHeader" :showChartViewBy=showChartViewBy ref="panelHeader" :panelHeaderData="pannelData" :controller="module" :graphType="type" :panelTitleNoBracket="panelTitle" :panelTitle="panelTitle" />
    
    <div v-if="rawData.totalMetric && (rawData.totalMetric.ContainedRate != -1 || rawData.totalMetric.HandedoffRate != -1)" class="conversation-vol-last-30-days-flex">
      <span class="conversation-vol-last-30-days-subheader">Total VA conversations 
        <span v-if="rawData.totalMetric" lass="total-conver-vol">{{bigNumberFormatter(rawData.totalMetric.NumberOfConversations).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
      </span>
      <span class="conversation-vol-last-30-days-progress-bar">
        <div class="w3-light-grey">
          <div class="w3-container w3-teal" v-if="rawData.totalMetric">
            
              <span class="progress-bar-percent-left" v-if="rawData.totalMetric && rawData.totalMetric.ContainedRate != -1" :style="{'width': Math.round(rawData.totalMetric.ContainedRate) + 9 + '%'}" ><span class="bar-percent">{{Math.round(rawData.totalMetric.ContainedRate)}}%</span></span>
              <span class="progress-bar-percent-left no-data" v-else :style="{'width': Math.round(100 - rawData.totalMetric.ContainedRate) + '%'}" ><span class="bar-percent">N/A</span></span>
  
              <span class="progress-bar-percent-right" v-if="rawData.totalMetric && rawData.totalMetric.HandedoffRate != -1" :style="{'width': Math.round(rawData.totalMetric.HandedoffRate) + 9 + '%'}"><span v-if="rawData.totalMetric.HandedoffRate !== 0" class="bar-percent">{{Math.round(rawData.totalMetric.HandedoffRate)}}%</span></span>
              <span class="progress-bar-percent-right no-data" v-else :style="{'width': Math.round(100 - rawData.totalMetric.HandedoffRate) + '%'}"><span class="bar-percent">N/A</span></span>

          </div>
        </div>
      </span>
      <span class="conversation-vol-last-30-days-legends">
        <div class="bottom-flex-container" v-if="rawData.totalMetric && rawData.totalMetric.NumberOfContainedConversations != -1">
          <span class="legend-flex"><div class="legend-marker" style="background-color: #5FBBAA"></div>Contained</span>
          <span class="legend-text">{{bigNumberFormatter(rawData.totalMetric.NumberOfContainedConversations).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
        </div>
        <div class="bottom-flex-container" v-else>
          <span class="legend-flex"><div class="legend-marker" style="background-color: #CAD2DA"></div>Contained</span>
          <span class="legend-text no-data" >N/A</span>
        </div>
        
        <div class="bottom-flex-container" v-if="rawData.totalMetric && rawData.totalMetric.NumberOfHandedOffConversation != -1">
          <span class="legend-flex"><div class="legend-marker" style="background-color: #4B67A3"></div>Handed off</span>
          <span class="legend-text">{{bigNumberFormatter(rawData.totalMetric.NumberOfHandedOffConversation).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
        </div>
        <div class="bottom-flex-container" v-else>
          <span class="legend-flex"><div class="legend-marker" style="background-color: #CAD2DA"></div>Handed off</span>
          <span class="legend-text no-data">N/A</span>
        </div>
      </span>
    </div>

    <div v-else class="no-data-flex"> 
      <div style="width: 100%; text-align: center;">
        <img class="no-data-image" src="../../../../../src/assets/icons/icon_performance_no_data.svg" alt="no data icon">
        <!-- <img class="no-data-image" src="../../../assets/icons/icon_no_data.svg" alt="no data icon"> -->
      </div>
      <span class="no-data-text">No data found</span>
      <span class="no-data-text-small">Try adjusting your date range or filters to find the information you're looking for.</span>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex';
  import WyPanelHeader from '../../wy-exp-and-auto-header.vue';
  //import WyPanelTabs from '../../panel-views/wy-panel-tabs.vue';
  //import WyPanelTabSection from '../../panel-views/wy-panel-tab-section.vue';
  import WyHomeUtils from '../../utils/wy-home-utils.js';

  export default Vue.extend({
    name: 'wy-home-experience-automation-panel-conversation-volume-summary',
    props: ["controller"],
    components: { 
      'wy-exp-and-auto-header': WyPanelHeader,
      //'wy-panel-tabs': WyPanelTabs,
      //'wy-panel-tab-section': WyPanelTabSection
    },

    data() {
      return {
        module: this,
        loading: false,
        templateData: {},
        rawData: {},
        pannelData: {},
        sectionData: {},
        type: 'bar',
        viewByHeader: 'Last 30 days',
        showChartViewBy: false,
        startDate: '',
        endDate: '',
        lineChartData: {},
        panelId: 'conversationVolLast30days',
        panelTitle: 'VA Conversation Volume',
        legendData: {},
        dataIndex: 0,
        dateRange: 'month'
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'companyConfig', 'legendDefaultColors']),
    },

    methods: {
      ...mapActions(['fetchConverVolLast30DaysChartData']),
      bigNumberFormatter(num) {
        if (num >= 1000000000) {
          return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
        }
        if (num >= 1000000) {
          return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
        }
        if (num >= 1000) {
          return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        }
        return num;
      },

      async changeDatePeriod(sDate, eDate, dateRangeType){
        this.startDate = sDate;
        this.endDate = eDate;
        this.viewByHeader = dateRangeType;
        await this.handleFilterChange()
      },
      renderLegendData() {
        if(this.sectionData.lineChartData) {
          this.legendData['legends'] = this.sectionData.lineChartData.legends
        }
        if(this.sectionData.pieChartData) {
          if(this.sectionData.lineChartData) {
            this.legendData['legends'] = this.sectionData.lineChartData.legends
          }
          if(this.sectionData.pieChartData) {
            this.legendData['legends'] = this.sectionData.pieChartData.legends
          }
        }

      },

      async handleFilterChange() {
        if((!this.loading && this.dataModel.dateEnd) ||this.dataModel.dateEnd) {
          this.loading = true;
          // DEMO: for demo purpose
          const demoConfigs = this.companyConfig.demoConfigs || {};
          const demoDateRange = demoConfigs[this.viewByHeader];
          if(demoDateRange && demoDateRange.startDate && demoDateRange.endDate) {
            this.startDate = demoDateRange.endDate;
            this.endDate = demoDateRange.startDate;
          }
          
          this.rawData = await this.fetchConverVolLast30DaysChartData([this.controller.selection, this.startDate, this.endDate]);
          // this.rawData.totalMetric.ContainedRate = -1 
          // this.rawData.totalMetric.HandedoffRate = -1
          if(this.rawData && Object.keys(this.rawData).length > 0 && this.rawData.totalMetric &&
          (this.rawData.totalMetric.ContainedRate != -1 || this.rawData.totalMetric.HandedoffRate != -1)) {
            this.templateData = WyHomeUtils.getHomeExpAndAutoConverVolLast30DaysData()
            // this.rawData.totalMetric.NumberOfContainedConversations = -1
            // this.rawData.totalMetric.NumberOfHandedOffConversation = -1
            //this.dateRange = this.controller.setDefaultDateRange();
            // let legendOriginColors = [];
            // if(this.companyConfig && this.companyConfig.legends && this.companyConfig.legends.legendColors && this.companyConfig.legends.legendColors.length > 0) {
            //   legendOriginColors = _.uniq(_.concat(this.companyConfig.legends.legendColors, this.legendDefaultColors));
            // }
            // else {
            //   legendOriginColors = this.legendDefaultColors
            // }
            // setTimeout(()=>{
            //   if(this.$refs.panelHeader && this.$refs.panelHeader.$refs && this.$refs.panelHeader.$refs.settingSection) {
            //     this.$refs.panelHeader.$refs.settingSection.selectedDateRange = this.dateRange;
            //   }
            // }, 100)
            this.loading = false;
            this.renderLegendData();
          }
          else {
            this.loading = false;
            this.pannelData = {};
            this.sectionData = {};
          }
        }
      },
    },

    async created(){
      await this.handleFilterChange();
      // this.$el.classList.add("full-size");
    }
  });
</script>

<style lang="scss">
  .tooltip-item-convo-vol{
    background: black !important;
    color: white !important;
    border-radius: 0px !important;
    padding: 5px !important;
    .popper__arrow:after{
      border-bottom-color: var(--site-font-chart-color) !important;
    }
  }

  .wy-home-experience-automation-panel-conversation-volume-summary {
    .el-loading-mask {
      // height: 656px !important;
      top: 65px !important;
    }
    .conversation-vol-last-30-days-flex {
      display: flex;
      margin-left: 14px;
      margin-top: 26px;
      flex-direction: column;
    }
    span.conversation-vol-last-30-days-subheader {
      font-size: 30px;
      font-weight: 400;
      color: var(--site-font-tertiary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
    span.total-conver-vol {
      font-size: 42px;
    }
    .w3-light-grey, .w3-hover-light-grey:hover, .w3-light-gray, .w3-hover-light-gray:hover {
      color: #000!important;
      height: 70px;
      background-color: #4B67A3!important;
    }
    .conversation-vol-last-30-days-progress-bar {
      width: 94%;
      margin-top: 65px;
      margin-bottom: 48px;
    }
    .legend-marker{
      border-radius: 50%;
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
    .legend-flex{
      display: flex;
      align-items: center;
      font-size: 20px;
      margin-right: 100px;
      font-weight: 400;
      color: var(--site-font-tertiary-color);
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
    .legend-text{
      margin-left: 20px;
      margin-top: 10px;
    }
    .bottom-flex-container {
      display: flex;
      font-size: 35px;
      font-weight: 400;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      flex-direction: column;
    }
    span.conversation-vol-last-30-days-legends {
      display: flex;
      margin-left: 6px;
      margin-top: 15px;
    }
    .w3-teal, .w3-hover-teal:hover {
      color: #fff!important;
      height: 70px;
      font-weight: 600;
      display: flex;
      font-size: 35px;
      height: 70px;
    }
    span.progress-bar-percent-right {
      display: flex;
      align-items: center;
      background-color: #4B67A3 !important;
    }
    span.progress-bar-percent-left{
      display: flex;
      background-color: #5FBBAA !important;
      align-items: center;
    }
    span.progress-bar-percent-right.no-data, .progress-bar-percent-left.no-data {
      background-color: #CAD2DA !important;
    }
    .bar-percent{
      margin-left: 20px;
    }
  
  }
</style>